const invoiceStatus = {
  open: 'open',
  late: 'late',
  pay: 'pay',
  not_released: 'not_released',
};

export default invoiceStatus;
